import React, {Component} from 'react';
import logo_laravel from "../../../img/stage/laravel.png";
import logo_mongodb from "../../../img/stage/MongoDB-Logo.svg";
import image_1 from "../../../img/stage/1/list_actualities_for_public.png";
import image_2 from "../../../img/stage/1/example_image_resizer_2.png";
import PdfRender from "../../layout/PdfRender";

export default class Stage1 extends Component{

	render() {
		return (
			<>
				<div className="service-area section-gap white">
					<div className="container">
						<div className="row">
							<div className="col-lg-3 col-md-6">
								<div className="single-service wow fadeInUp py-4" data-wow-duration="0.8s">
									<span className="lnr lnr-apartment"> </span>
									<h4>
										<span>Entreprise</span> d'acceuil
									</h4>
									<p>
										FreeForBiz <br/>
										1O Ter Rue Ledru Rollin <br/>
										66000 PERPIGNAN <br/>
										09 50 30 12 33 <br/>
										contact@yakabiz.com <br/>
										<a href="https://yakabiz.com">Site web</a>
									</p>
								</div>
							</div>
							<div className="col-lg-9 col-md-6">
								<div className="row">
									<div className="col-lg-12">
										<div className="section-title">
											<h2>Information</h2>
											<div>
												<div><b>❯ Project(s) : </b> MasterBiz</div>
												<div><b>❯ Technologie(s) : </b> Php, Javascript, NodeJS</div>
												<div><b>❯ Framework : </b> Laravel (php), Quill JS, VueJS</div>
												<div><b>❯ Base de données : </b> MySQL, MongoDB</div>
											</div>
										</div>
									</div>
								</div>
							</div>



							<div className="col-lg-12 mt-5">
								<h3 className="text-heading">Technologie Principal</h3>

								<h4 className="mb-20">Laravel</h4>

								<div className="row my-5">
									<div className="col-md-4">
										<img src={logo_laravel} alt="" className="img-fluid" />
									</div>
									<div className="col-md-8 mt-sm-20 text-left">
										<p>
											<a href="https://laravel.com/">Laravel</a> est un framework PHP qui propose des outils pour construire une application web.
											Le créateur de Laravel, Taylor Otwel, a simplement regroupé les meilleures librairies pour chaque fonctionnalité nécessaire pour la création d’un site web.
											Il a aussi rajouté des fonctionnalités exclusives, comme le moteur de template Blade.
											Laravel poséde un logique de creation d’application web qu'il faura adopter,
											mais aussi des fonctionnalités liées au stockage des données extrênement efficace (ORM Eloquent).
										</p>
									</div>
								</div>

								<h4 className="mb-20">MongoDB</h4>

								<div className="row my-5">
									<div className="col-md-4">
										<img src={logo_mongodb} alt="" className="img-fluid" />
									</div>
									<div className="col-md-8 mt-sm-20 text-left">
										<p>
											<a href="https://www.mongodb.com/fr">Mongodb</a> est un SGBD orienté documents, et non relationnel.<br/><br/>

											Le document est l'unité de base : il peut être inséré, supprimé, recherché...
											On peut manipuler simultanément des types de documents différents sans mettre en place la moindre contrainte entre ceux-ci.
											Les documents sont contenus dans des collections réunies en bases de données.
										</p>
									</div>
								</div>
							</div>

							<div className="col-lg-12 mt-3">
								<h3 className="text-heading">MasterBiz</h3>

								<h4 className="mb-20">Presentation</h4>
								<p>
									Masterbiz est application web créer par l'entreprise <a href="https://yakabiz.com">Yakabiz</a> (anciènement nommé FreeForBiz).
									C'est une application de gestion des performances et des activités d'une entreprise. <br/>

									C'est une application web principalement ecrit en PHP utilisant le framework Laravel.
								</p>

								<h4 className="mb-20">Mon travail</h4>

								<div className="row my-5">
									<div className="col-md-4">
										<a href={image_1} className="img-gal">
											<img src={image_1} alt="" className="img-fluid" />
										</a>
									</div>
									<div className="col-md-8 mt-sm-20 text-left">
										<p>
											Mon travail au sein de l'entreprise été de rajouter un nouveau module au projet MasterBiz. <br/>
											<b>Un module d'actualité</b> et bien sur comme c'était la première fois que je travailler avec le framework <b>Laravel</b> j'ai du m'adapter à un nouvel environment de travail,
											sans oublier que j'ai des collegues voir <a href="#Versionning">Versionning</a>
										</p>
									</div>
								</div>
								<div className="row my-5">
									<div className="col-md-8 mt-sm-20 text-right">
										<p>
											Côté Javascript, je devais aussi apprendre à utiliser VueJS.
											J'ai notament réussi à intéger un <a href="https://fr.wikipedia.org/wiki/What_you_see_is_what_you_get">WYSIWYG</a> (<a href="https://quilljs.com/">QuillJS</a>) qui permet actuellement l'édition des articles des news sur l'application. <br/>

											<span className="text-muted">
														Le resize sur l'image n'est pas disponible directement avec QuillJS, j'ai du intgérer un plugin pour voir cette fontionnalité en plus.
													</span>
										</p>
									</div>
									<div className="col-md-4">
										<a href={image_2} className="img-gal">
											<img src={image_2} alt="" className="img-fluid" />
										</a>
									</div>
								</div>

								<h4 className="mb-20" id="Versionning">Planing, Organisation, Versioning, ...</h4>

								<p>
									En guise de versionning de projet, on utilisait <a href="https://bitbucket.org/product/">Bitbucket</a> pour heberger le code, et on utilisait <a href="https://git-fork.com/">Fork git</a> comme client git.
								</p>

							</div>

							{/*<div className="col-lg-12 mt-3">
								<h3 className="text-heading">Attestation de fin de stage 1</h3>

								<div className="col-lg-12 d-flex flex-column justify-content-center">
									<div className="wrapper-pdf">
										<PdfRender file="./../storage/Attestation_de_stage_periode_1_-_logo.pdf" />
									</div>
								</div>
							</div>*/}

						</div>
					</div>
				</div>
			</>
		);
	}

}